import React, {Component} from 'react'
import {connect} from 'react-redux'
import cs from 'classnames'
import HtmlContent from './HtmlContent'
import DateValue from './DateValue'
import styles from './news.scss'
import {showPrintModal} from 'state/actions'
import i18n, {sourceIdToObj} from 'lib/i18n'
const _ = i18n()

const getIcon = () => {
    try {
        return require(`resources/images/print-black-18dp.svg`)
    } catch(err) {
        return require(`resources/images/icn-no-result.svg`)
    }
}

@connect(
	state => ({
		...state.news,
        newsId: state.app.opened,
	})
)
export default class NewsList extends Component {
    static propTypes = {
		id: React.PropTypes.string.isRequired,
		date: React.PropTypes.string.isRequired,
		onOpen: React.PropTypes.func.isRequired,
        isFirst: React.PropTypes.bool.isRequired,
		isActive: React.PropTypes.bool.isRequired,
		isLast: React.PropTypes.bool.isRequired,
		teaser: React.PropTypes.string.isRequired,
		title: React.PropTypes.string.isRequired,
    }

    modalPrintNews(news) {
        const {dispatch} = this.props

        dispatch(showPrintModal(
            "newsPrintModal",
            news.title,
            news.content,
            "",
            null,
            {hasCancelButtonStyle: false}
        ))
    }

    render() {
        const {id, date, onOpen, isFirst, isActive, isLast, teaser, title, content, sourceIds} = this.props
        return (
            <div
                onClick={() => onOpen(id)}
                className={cs(
                    styles.newsItem,
                    isActive && styles.active,
                    isFirst && styles.first,
                    isLast && styles.last,
                )}
            >
                <div className={styles.newsInfoDiv} >
                    <p className={styles.newsTitle}>{title}
                        <img className={styles.printIcon}
                            src={getIcon()}
                            onClick={(e) => {
                                e.preventDefault()
                                const theWindow = window.open('', 'PRINT', 'height=600,width=800')
                                theWindow.document.write('<html  style="overflow-y: hidden"><head><title>' + title  + '</title>')
                                theWindow.document.write('<style>')
                                // this line of css made from HtmlContent.scss -> replace variables -> convert to css -> minify
                                theWindow.document.write(".content{height:95%;overflow-y:scroll}.content ol,.content p,.content ul{margin:0 0 10px;color:#404548}.content em{font-style:italic}.content strong{font-weight:700}.content p.highlight{font-weight:700}.content p.bullet{padding-left:1em;text-indent:-1em}.content p.bullet::before{content:'•';padding-right:.5em}.content ol,.content ul{padding-left:20px}.content ol li,.content ul li{margin-left:1em}.content ol{list-style-type:decimal}.content ul{list-style-type:circle}.content h1{font-size:1.4em}.content h2{font-size:1.2em}.content h1,.content h2,.content h3,.content h4,.content h5,.content h6{font-weight:lighter;margin-top:1em;margin-bottom:.5em}.content hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.content blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}.content pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}.content pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.elements-news-title h2{color: #404548;font-size: 34px;font-weight: 600;}")
                                theWindow.document.write('</style>')
                                theWindow.document.write('</head><body class="content">')
                                theWindow.document.write('<div class="elements-news-title"><h2>'+ title + '</h2></div>')
                                theWindow.document.write(content)
                                theWindow.document.write('</body><footer><div class="linkList">')
                                theWindow.document.write(_('news_sources') + ': ')
                                sourceIds.map((sourceId, i) => {
                                    const source = sourceIdToObj(sourceId)
                                    theWindow.document.write(`<a href="${source.url}" target="_blank" rel="noopener noreferrer">${source.name}</a>`)
                                })
                                theWindow.document.write('</div></footer></html>')
                                theWindow.document.close() // IE >= 10
                                theWindow.focus() // IE >= 10
                                theWindow.print()
                                // with preview modal
                                /* this.modalPrintNews({title, content}) */
                        }}/>
                    </p>
                    {date && <DateValue className={styles.date} date={date}/>}
                    {teaser &&
                    <div className={styles.teaser}>
                        <HtmlContent className="" content={teaser}/>
                    </div>}
                </div>
            </div>
        )}

}



// WEBPACK FOOTER //
// ./elements/NewsCell.jsx